import type { ActivationAlertsContractNewsTopic } from "@similarweb/pro-api-client";

import { DEFAULT_TOPIC_KEY, topicTranslationKeyMap } from "./translationKeysConfig";

export const getTopicTranslationKey = (topic: ActivationAlertsContractNewsTopic): string => {
    return topicTranslationKeyMap[topic] ?? DEFAULT_TOPIC_KEY;
};
